import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { getCategoriesDomains, getBrandsDomains } from './utils/api.js';
import CategoryNameTilesBlock from './components/CategoryNameTilesBlock/CategoryNameTilesBlock.js';
import ContentPartnersNameTilesBlock from './components/ContentPartnersNameTilesBlock/ContentPartnersNameTilesBlock.js';

ReactDOM.render(
    <CategoryNameTilesBlock
        blockTitle={'Course Categories'}
        blockTitleClass={'course-categories__title ubuntu--light h2'}
        data={getCategoriesDomains}
    />,
    document.getElementById('courseCategories')
);

ReactDOM.render(
    <ContentPartnersNameTilesBlock
        blockTitle={'Content Partner Categories'}
        blockTitleClass={'course-categories__title ubuntu--light h2'}
        excludedBrandIds={[1]}
        data={getBrandsDomains}
    />,
    document.getElementById('contentPartnersCategories')
);